module.exports = __webpack_public_path__ + "img/ic_location.d485eb1d.svg";